module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-st.e213e764.png";